import React, { useEffect, useRef } from "react";  // ADDED useRef
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { track } from "../utils/analytics";
import "../styles/PaymentSuccess.css";

function PaymentSuccess() {
  const navigate = useNavigate();
  const { user_id } = useParams();
  const [searchParams] = useSearchParams();

  const accountType = searchParams.get("account_type") || "unknown";
  const planId      = searchParams.get("plan")         || "unknown";

  // ---------- analytics: page view + purchase success ----------
  useEffect(() => {
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Payment Success",
    });

    track("purchase_success", {
      account_type: accountType,
      plan_id     : planId,
      value       : searchParams.get("amount") || undefined, // GA4 “value”
      currency    : searchParams.get("currency") || "USD",
    });

    // mark the user as paying subscriber
    window.gtag?.("set", "user_properties", {
      is_subscriber: true,
      account_type : accountType,
    });
  }, [accountType, planId, searchParams]);

  // ---------- Google Ads conversion (fire once) ----------
  const conversionFiredRef = useRef(false); // ADDED

  useEffect(() => {
    if (conversionFiredRef.current) return;      // guard for StrictMode
    conversionFiredRef.current = true;

    const valueStr  = searchParams.get("amount");
    const currency  = searchParams.get("currency") || "USD";

    // Prefer a stable transaction id you also use server-side (e.g. Stripe session_id)
    const txid =
      searchParams.get("session_id") ||
      searchParams.get("transaction_id") ||
      `${user_id || "anon"}-${Date.now()}`;

    // Number() ensures a numeric value (Ads expects a number, not string)
    const valueNum = valueStr ? Number(valueStr) : 0;

    window.gtag?.("event", "conversion", {
      send_to       : "AW-17323182389/BQGqCLGg3PgaELWSq8RA",
      value         : valueNum,
      currency      : currency,
      transaction_id: txid,
    });
  }, [searchParams, user_id]); // ADDED

  // ---------- redirect after 10s ----------
  useEffect(() => {
    const timer = setTimeout(() => {
      track("post_payment_redirect", {
        account_type: accountType,
        plan_id     : planId,
        destination : accountType === "business"
          ? `/venue_selection/${user_id}`
          : `/find_venues/${user_id}`,
      });

      if (accountType === "business")
        navigate(`/venue_selection/${user_id}`);
      else
        navigate(`/find_venues/${user_id}`);
    }, 10_000);

    return () => clearTimeout(timer);
  }, [navigate, user_id, accountType, planId]);

  // ---------- render ----------
  return (
    <div className="payment-success-container">
      <div
        className="logo"
        onClick={() =>
          track("navigation_click", {
            location   : "payment_success",
            nav_item   : "Logo",
            destination: "/",
          })
        }
      >
        <a href="/">BestDay2Marry</a>
      </div>

      <div className="payment-message">
        <h1>Payment Successful!</h1>
        <p>You will be redirected shortly to continue the matching process.</p>
      </div>

      <div className="spinner" />
    </div>
  );
}

export default PaymentSuccess;
